import {TalentSkillSubscriber} from "../../_helper/DataBehaves";
import {ICharSkill} from "../../_interfaces/ICharSkill";

const getSkillDefines = (skill: ICharSkill) => {
    for (let j = 0; j < TalentSkillSubscriber.value.length; j++) {
        if (TalentSkillSubscriber.value[j].hasOwnProperty('lps_skill') && TalentSkillSubscriber.value[j].name === skill.name) {
            skill.define_single = TalentSkillSubscriber.value[j].hasOwnProperty('define_single') ? TalentSkillSubscriber.value[j].define_single : []
            skill.define_multi = TalentSkillSubscriber.value[j].hasOwnProperty('define_multi') ? TalentSkillSubscriber.value[j].define_multi : []
            break;
        }
    }
    return skill;
}

export default getSkillDefines;